import React, { useCallback, useMemo, useState } from 'react';
import { SectionStatusCtx, type SectionStatus, type SectionStatusApi } from 'shared/state/sectionStatusContext';

export function SectionStatusProvider({ children }: { children: React.ReactNode }) {
  const [statuses, setStatuses] = useState<Record<string, SectionStatus>>({});

  const report = useCallback((id: string, status: SectionStatus) => {
    setStatuses((prev) => (prev[id] === status ? prev : { ...prev, [id]: status }));
  }, []);

  const clear = useCallback((id: string) => {
    setStatuses((prev) => {
      if (!(id in prev)) return prev;
      const next = { ...prev };
      delete next[id];
      return next;
    });
  }, []);

  const value = useMemo<SectionStatusApi>(() => ({ statuses, report, clear }), [statuses, report, clear]);
  return <SectionStatusCtx.Provider value={value}>{children}</SectionStatusCtx.Provider>;
}
